import React from "react";

import { CloseIcon } from "@fluentui/react-icons-northstar";

import { Dialog } from "@fluentui/react-northstar";

const ConfirmDialog = (props) => {
  return (
    <div>
      <Dialog
        {...props}
        open={props.isConfirmDelete}
        onOpen={() => props.setisConfirmDelete(true)}
        onCancel={() => props.onCancel(false)}
        onConfirm={() => props.onConfirm(true)}
        confirmButton={props.confirmButton}
        cancelButton={props.cancelButton}
        content={props.content}
        header={props.header}
        headerAction={{
          icon: <CloseIcon />,
          title: "Close",
          onClick: () => {
            props.setisConfirmDelete(false);
          },
        }}
        trigger={props.button}
        id={props.id}
      />
    </div>
  );
};

export default React.memo(ConfirmDialog);
